import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Chip,
} from "@mui/material";
import { toast } from "react-toastify";

import api from "../services/api";
import { dynamicStatus } from "./../utils/index";

import { useDispatch } from "react-redux";

const TransactionDetail = () => {
  const { transactionId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const UploadId = queryParams.get("UploadId");
  const id = queryParams.get("Id");
  const navigate = useNavigate();
  const [record, setRecord] = useState(null);
  const [historyData, setHistoryData] = useState({});
  const [daoHistoryData, setDaoHistoryData] = useState({});
  const [updateRequests, setUpdateRequests] = useState([]);
  const [columsHeaders, setColumsHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log(updateRequests, "updateRequests");
  useEffect(() => {
    if (!UploadId || !id) {
      navigate(-1);
      return;
    }

    const fetchRecord = async () => {
      try {
        const response = await api.get(
          `upload-request/record/${id}/${UploadId}`
        );
        setColumsHeaders(response?.data?.data?.columns);
        setRecord(response?.data?.data?.data);
        setHistoryData(response?.data?.data?.history);
        setDaoHistoryData(response?.data?.data?.dao_history);
        let updateRequests = response?.data?.data?.updateRequests;
        if (Array.isArray(updateRequests) && updateRequests.length > 0) {
          setUpdateRequests(updateRequests?.reverse());
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message &&
            typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Error fetching data, please try again."
        );
        // navigate("/dashboard");
        navigate(`/report/${UploadId}`);
      } finally {
        setLoading(false);
      }
    };

    fetchRecord();
  }, [transactionId, navigate]);

  function formatCustomDate(date) {
    if (!date) return "-";

    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} ${time}`;
  }

  const [daoHistoryOriginalData, setDaoHistoryOriginalData] = useState([]);
  let getFun = () => {
    let originalVal = [];
    let childObj = [];
    let variableIndex =
      daoHistoryData?.jsonData?.[0]?.record?.allDao?.split(",")?.length;
    daoHistoryData?.jsonData?.forEach((item, index) => {
      if (variableIndex > index) {
        childObj.push(item);
      }
      if (variableIndex === index) {
        originalVal.push(childObj);
        childObj = [];
        childObj.push(item);
        variableIndex =
          variableIndex + item?.record?.allDao?.split(",")?.length;
      }
      console.log(originalVal, childObj, variableIndex, index, "variableIndex");
    });
    originalVal.push(childObj);
    setDaoHistoryOriginalData([...originalVal]);
  };
  useEffect(() => {
    if (daoHistoryData?.jsonData) {
      getFun();
    }
  }, [daoHistoryData]);
  console.log(daoHistoryOriginalData, "daoHistoryOriginalData");
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop={2}
        mb={1}
      >
        <Box textAlign="center">
          <img
            src="../full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" sx={{ mt: 3 }}>
        {/* Transaction Details */}
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                {/* // title="Transaction Details"
                // subheader={`Details of Transaction ID: ${
                //   record?.transactionId ? record?.transactionId : ""
                // }`}
                // titleTypographyProps={{ variant: "h5", fontWeight: "bold" }}
                // subheaderTypographyProps={{ variant: "subtitle1" }} */}
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={9}>
                    <Typography fontSize="24px" fontWeight="bold">
                      Transaction Details
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ wordBreak: "break-all" }}
                    >
                      <strong>Transaction ID: </strong>
                      {record?.hash_id ? record?.hash_id : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        navigate(`/report/${UploadId}`);
                        // dispatch(setReportPageNumber(0));
                        // dispatch(setDashboardPageNumber(0));
                        // dispatch(setReportSearchValue(""));
                      }}
                      sx={{ textTransform: "none" }}
                    >
                      Back to Report Details
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  {columsHeaders?.map((item) => {
                    return (
                      item !== "position" && (
                        <Grid item xs={12} sm={4}>
                          <Typography fontWeight="bold">
                            {item?.toUpperCase()}
                          </Typography>
                          <Typography
                            style={{
                              wordBreak: "break-all",
                            }}
                            variant="body1"
                            gutterBottom
                          >
                            {record?.[item?.toLowerCase()]
                              ? record?.[item?.toLowerCase()]
                              : "-"}
                          </Typography>
                        </Grid>
                      )
                    );
                  })}
                  {/* <Grid item xs={12} sm={4}>
                    <Typography fontWeight="bold">Student Name</Typography>
                    <Typography variant="body1" gutterBottom>
                      {record?.name ? record?.name : "-"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography fontWeight="bold">Roll Number</Typography>
                    <Typography variant="body1" gutterBottom>
                      {record?.rollNumber ? record?.rollNumber : "-"}
                    </Typography>
                  </Grid> */}
                  <Grid item xs={12} sm={4}>
                    <Typography fontWeight="bold">Examination Board</Typography>
                    <Typography variant="body1" gutterBottom>
                      Bihar Board
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Typography fontWeight="bold">Updated At</Typography>
                    <Typography variant="body1" gutterBottom>
                      {record?.createdAt
                        ? formatCustomDate(record.createdAt)
                        : "-"}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Updated Records */}

        {updateRequests?.map((updateRequestItem, index) => {
          const finalStatusAVailable = updateRequestItem?.approvals?.every(
            (obj) => obj.is_approved !== "0"
          );
          const isApprovalStatus = updateRequestItem?.approvals?.every(
            (obj) => obj.is_approved === "1"
          );
          const updatedapprovals = updateRequestItem?.approvals?.sort(
            (a, b) => a.dao_id - b.dao_id
          );
          // console.log(updatedapprovals, "updatedapprovals");
          return (
            <Paper
              sx={{
                mt: 3,
                p: 3,
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {/* {daoHistoryOriginalData?.[index]?.map(
                      (daoHistoryOriginalDataitem) => {
                        return (
                          <Grid item xs={12} sm={6} md={7}>
                            <Typography fontWeight="bold" gutterBottom>
                              DAO1 Transaction Id
                            </Typography>
                            <Typography
                              gutterBottom
                              style={{ wordWrap: "break-word" }}
                            >
                              {daoHistoryOriginalDataitem?.txId
                                ? daoHistoryOriginalDataitem?.txId
                                : "-"}
                            </Typography>
                          </Grid>
                        );
                      }
                    )} */}
              <Box width="100%">
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ wordBreak: "break-all" }}
                >
                  <strong> Transaction ID: </strong>
                  {historyData?.jsonData?.[index]?.txId
                    ? historyData?.jsonData?.[index]?.txId
                    : "_"}
                </Typography>
                <Divider sx={{ mb: 1 }} />
                {updateRequestItem?.approvals?.map((approval, index) => {
                  return (
                    <Grid
                      container
                      spacing={3}
                      style={{
                        marginBottom: "50px",
                      }}
                    >
                      <Grid item xs={12} sm={6} md={7}>
                        <Typography fontWeight="bold" gutterBottom>
                          DAO {index + 1} Transaction Id
                        </Typography>
                        <Typography
                          gutterBottom
                          style={{ wordWrap: "break-word" }}
                        >
                          {approval?.transaction_id
                            ? approval?.transaction_id
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4} md={3}>
                        <Typography fontWeight="bold" gutterBottom>
                          DAO {index + 1} Action Date
                        </Typography>
                        <Typography gutterBottom>
                          {approval?.updatedAt && approval?.transaction_id
                            ? formatCustomDate(approval?.updatedAt)
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={2} md={2}>
                        <Typography fontWeight="bold" gutterBottom>
                          Status
                        </Typography>
                        <Typography gutterBottom>
                          {approval?.is_approved ? (
                            <Chip
                              label={
                                approval?.is_approved === "1"
                                  ? "Approved"
                                  : approval?.is_approved === "0"
                                  ? "Pending"
                                  : "Rejected"
                              }
                              color={dynamicStatus(
                                approval?.is_approved === "1"
                                  ? "Approved"
                                  : approval?.is_approved === "0"
                                  ? "Pending"
                                  : "Rejected"
                              )}
                            />
                          ) : (
                            "-"
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={7}>
                        <Typography fontWeight="bold" gutterBottom>
                          Remarks
                        </Typography>
                        <Typography
                          gutterBottom
                          style={{ wordWrap: "break-word" }}
                        >
                          {approval?.remarks ? approval?.remarks : "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}

                <Divider sx={{ mb: 1 }} />
              </Box>
              <Grid container spacing={3}>
                <Grid item xs={8} sm={4}>
                  <Typography fontWeight="bold">Previous Values</Typography>
                  <Divider sx={{ my: 1 }} />
                  {columsHeaders?.map((columsHeadersItem) => {
                    if (
                      updateRequestItem?.new_value?.[columsHeadersItem] !==
                      updateRequestItem?.old_value?.[columsHeadersItem]
                    ) {
                      return (
                        <Typography
                          style={{
                            wordBreak: "break-word",
                          }}
                          marginBottom={1}
                        >
                          <strong>{columsHeadersItem?.toUpperCase()}:</strong>{" "}
                          {updateRequestItem?.old_value?.[columsHeadersItem]
                            ? updateRequestItem?.old_value?.[columsHeadersItem]
                            : " -"}
                        </Typography>
                      );
                    }
                  })}
                </Grid>
                <Grid item xs={8} sm={4}>
                  <Typography fontWeight="bold">New Values</Typography>
                  <Divider sx={{ my: 1 }} />
                  {columsHeaders?.map((columsHeadersItem) => {
                    if (
                      updateRequestItem?.new_value?.[columsHeadersItem] !==
                      updateRequestItem?.old_value?.[columsHeadersItem]
                    ) {
                      return (
                        <Typography
                          marginBottom={1}
                          style={{
                            wordBreak: "break-word",
                          }}
                        >
                          <strong>{columsHeadersItem?.toUpperCase()}:</strong>{" "}
                          {updateRequestItem?.new_value?.[columsHeadersItem]
                            ? updateRequestItem?.new_value?.[columsHeadersItem]
                            : " -"}
                        </Typography>
                      );
                    }
                  })}
                </Grid>
                <Grid item xs={8} sm={4}>
                  <Typography fontWeight="bold">Final Status</Typography>
                  <Divider sx={{ my: 1 }} />

                  <Chip
                    label={
                      finalStatusAVailable
                        ? isApprovalStatus
                          ? "Approved"
                          : "Rejected"
                        : "Pending"
                    }
                    color={dynamicStatus(
                      finalStatusAVailable
                        ? isApprovalStatus
                          ? "Approved"
                          : "Rejected"
                        : "Pending"
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          );
        })}
      </Container>
    </>
  );
};

export default TransactionDetail;
